/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const BetweenFilesize: core.serialization.ObjectSchema<
    serializers.BetweenFilesize.Raw,
    Truvity.BetweenFilesize
> = core.serialization.object({
    left: core.serialization.number(),
    right: core.serialization.number(),
});

export declare namespace BetweenFilesize {
    export interface Raw {
        left: number;
        right: number;
    }
}
